import React from 'react';
import { generatePath, Navigate, useSearchParams } from 'react-router-dom';
import track from 'react-tracking';

import CheckoutView from 'components/Membership/CheckoutView';
import { RENEW_CHANNEL } from 'config/channels';
import { PAGE_PATHS } from 'config/routes';
import StripePaymentContextProvider from 'contexts/StripePaymentContext/StripePaymentContext';
import { PageLoader } from 'elements';
import useFetchOffers from 'hooks/api/offers/useFetchOffers';
import useFetchMyProfile from 'hooks/api/userProfiles/useFetchMyProfile/useFetchMyProfile';
import { usePreferencesStore } from 'stores/preferences';
import { usePageTracking } from 'utils/tracking';

const goToEmailStep = (searchParams: URLSearchParams) => {
  return (
    <Navigate
      to={{
        pathname: generatePath(PAGE_PATHS.MEMBERSHIPS.BUY_PAGE),
        search: searchParams.toString(),
      }}
    />
  );
};

const CheckoutPage = () => {
  usePageTracking();

  const [searchParams] = useSearchParams();
  const { data: userProfile, isLoading: isLoadingUserProfile } =
    useFetchMyProfile();
  const { isLoading: isLoadingOffers, data } = useFetchOffers();
  const setCurrency = usePreferencesStore((state) => state.setCurrency);

  if (!userProfile && !isLoadingUserProfile) {
    return goToEmailStep(searchParams);
  }

  if (isLoadingOffers || isLoadingUserProfile) {
    return <PageLoader />;
  }

  if (data) {
    const offers = data.offers;
    const renewOffer = data.renewOffer;

    // NOTE: this is a temporary solution for payout membership renewals with unsupported currency
    if (
      renewOffer?.paymentFrequency === 'single' &&
      searchParams.get('channel') === RENEW_CHANNEL
    ) {
      setCurrency('EUR');
    }

    return (
      <StripePaymentContextProvider>
        <CheckoutView offers={offers} renewOffer={renewOffer} />
      </StripePaymentContextProvider>
    );
  }
  return goToEmailStep(searchParams);
};

export default track({ page_type: 'Memberships.Buy.Checkout' })(CheckoutPage);
